import { NgModule } from '@angular/core';
import { CommaPipe } from './comma.pipe';

@NgModule({
  declarations: [CommaPipe],
  exports: [CommaPipe],
})
export class CommaPipeModule {}
